import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, auth, API_BASE } from "../../lib/api";
import { useT } from "../../lib/i18n";
import axios from "axios";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { toast } from "sonner";

export default function Login() {
  const t = useT();
  const nav = useNavigate();
  const [email, setEmail] = useState("owner@brimo.de");
  const [password, setPassword] = useState("Brimo!2026");
  const [tenant, setTenant] = useState("brimo");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await axios.post(`${API_BASE}/auth/login`, {
        email, password, tenant_slug: tenant,
      });
      auth.setSession({
        access_token: res.data.access_token,
        refresh_token: res.data.refresh_token,
        tenant_slug: tenant,
      });
      // fetch user profile
      try {
        const me = await api.get("/users/me");
        auth.setSession({ user: me.data });
      } catch (_) {}
      toast.success("Signed in");
      // Phase 6 — single post-login redirect target. The landing
      // route decides operator vs. tenant + onboarding.
      nav("/app");
    } catch (err) {
      const d = err?.response?.data;
      // Phase 6 — distinct plain-german hint for pending / rejected.
      const msg = d?.message;
      if (msg === "pending_approval") {
        toast.error(
          "Konto wartet auf Freigabe durch Plattform-Betreiber.",
          { duration: 8000 },
        );
      } else if (msg === "account_rejected") {
        toast.error("Antrag wurde abgelehnt.");
      } else {
        toast.error(d?.detail || d?.message || t("auth.invalid_credentials"));
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="size-9 rounded-md bg-foreground text-background grid place-items-center font-semibold">V</div>
            <span className="text-lg font-semibold tracking-tight">VIONA</span>
          </div>
          <h1 className="text-3xl font-semibold tracking-tight">
            {t("auth.welcome")} <span className="text-muted-foreground">Marketing OS</span>
          </h1>
          <p className="text-sm text-muted-foreground mt-1">{t("auth.subtitle")}</p>
        </div>
        <Card>
          <CardHeader>
            <CardTitle>{t("auth.sign_in")}</CardTitle>
            <CardDescription>{t("auth.subtitle")}</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4" data-testid="login-form">
              <div className="space-y-2">
                <Label htmlFor="tenant">{t("auth.tenant")}</Label>
                <Input id="tenant" data-testid="login-tenant" value={tenant} onChange={(e) => setTenant(e.target.value)} required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="email">{t("auth.email")}</Label>
                <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">{t("auth.password")}</Label>
                <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              </div>
              <Button type="submit" data-testid="login-submit" disabled={busy} className="w-full">
                {busy ? t("common.loading") : t("auth.sign_in")}
              </Button>
              <p className="text-center text-sm text-muted-foreground">
                {t("auth.no_account")}{" "}
                <Link to="/register" className="underline" data-testid="link-register">{t("auth.sign_up")}</Link>
              </p>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
